// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProductsCartPage_wrapper__3K9D1","sidebar":"ProductsCartPage_sidebar__1E-xa"};